var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8031 20.1816C12.5471 20.1816 12.2911 20.0843 12.0965 19.8883C11.7058 19.4976 11.7058 18.8656 12.0965 18.4749L18.4858 12.0856C18.8765 11.6949 19.5085 11.6949 19.8991 12.0856C20.2898 12.4763 20.2898 13.1083 19.8991 13.4989L13.5098 19.8883C13.3151 20.0843 13.0591 20.1816 12.8031 20.1816Z",
    fill: "#B8BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1951 20.1857C18.9391 20.1857 18.6831 20.0884 18.4884 19.8924L12.0938 13.4964C11.7031 13.1057 11.7031 12.4737 12.0938 12.083C12.4858 11.6924 13.1178 11.6924 13.5071 12.083L19.9018 18.479C20.2924 18.8697 20.2924 19.5017 19.9018 19.8924C19.7071 20.0884 19.4498 20.1857 19.1951 20.1857Z",
    fill: "#B8BAC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2198 4.66717C6.8465 4.66717 4.6665 6.97784 4.6665 10.5552V21.4458C4.6665 25.0232 6.8465 27.3338 10.2198 27.3338H21.7772C25.1518 27.3338 27.3332 25.0232 27.3332 21.4458V10.5552C27.3332 6.97784 25.1518 4.66717 21.7785 4.66717H10.2198ZM21.7772 29.3338H10.2198C5.70117 29.3338 2.6665 26.1632 2.6665 21.4458V10.5552C2.6665 5.83784 5.70117 2.66718 10.2198 2.66718H21.7785C26.2972 2.66718 29.3332 5.83784 29.3332 10.5552V21.4458C29.3332 26.1632 26.2972 29.3338 21.7772 29.3338Z",
    fill: "#B8BAC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.c4fd058d.svg";
export { ForwardRef as ReactComponent };